// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__NaSWO","upload":"Small_upload__1X-4b","imageWrap":"Small_imageWrap__1cTyB","removeBtn":"Small_removeBtn__3GxU0"};